module.exports = __webpack_public_path__ + "img/m12.7dc5ed18.jpg";